<div class="content-panel filters">
  <div
    class="d-flex align-items-center cursor-pointer"
    (click)="showFilters = !showFilters"
    >
    <div class="title mb-0">Filtri</div>
    @if (values.length > 0) {
      <div
        class="badge ms-2 d-flex align-items-center justify-content-center"
        >
        <div>{{ values.length }}</div>
      </div>
    }
    <i
      class="ms-auto action feather"
      [class]="{
        'icon-chevron-down': !showFilters,
        'icon-chevron-up': showFilters
      }"
    ></i>
  </div>
  <form (submit)="search()" [formGroup]="form" [ngbCollapse]="!showFilters">
    <ng-content></ng-content>
    <div class="mt-2 d-flex">
      <div class="row flex-grow-1">
        @for (
          filter of filterConfig; track filterField(i,
          filter); let i = $index) {
          @if (!filter.showIntoMoreFilters) {
            <div
              class="col-md-6 col-lg-3 ellf-form-field"
              >
              <ellf-single-filter
                [label]="filter.elementLabel"
                [items]="filter.elementValues || []"
                [field]="filter.field"
                [entityName]="filter.entityName"
                [type]="filter.filterType"
                [formControlName]="filter.field"
                [readOnly]="filter.readOnly"
              ></ellf-single-filter>
            </div>
          }
        }
      </div>
    </div>
    @if (existsMoreFilters) {
      <div
        class="d-flex align-items-center text-primary"
        >
        <div class="fw-bolder">Altri filtri</div>
        <i
          class="ms-2 action feather cursor-pointer"
        [class]="{
          'icon-arrow-down-circle': !showMoreFilters,
          'icon-arrow-up-circle': showMoreFilters
        }"
          (click)="showMoreFilters = !showMoreFilters"
        ></i>
      </div>
    }
    @if (existsMoreFilters) {
      <div
        class="mt-3"
        [ngbCollapse]="!showMoreFilters"
        >
        <div class="row flex-grow-1">
          @for (
            filter of filterConfig; track filterField(i,
            filter); let i = $index) {
            @if (filter.showIntoMoreFilters) {
              <div
                class="col-md-6 col-lg-3 ellf-form-field"
                >
                <ellf-single-filter
                  [label]="filter.elementLabel"
                  [items]="filter.elementValues || []"
                  [type]="filter.filterType"
                  [formControlName]="filter.field"
                  [readOnly]="filter.readOnly"
                  [entityName]="filter.entityName"
                  [field]="filter.field"
                ></ellf-single-filter>
              </div>
            }
          }
        </div>
      </div>
    }
    <div class="mt-3 action-button-container">
      <button class="btn btn-primary action-button" type="submit">
        Applica
      </button>
      <button class="btn clear action-button" (click)="reset()" type="reset">
        Pulisci filtri
      </button>
    </div>
  </form>
</div>
